/** Required element lookup — the markup lives in index.html, so a miss is a programming error. */
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters -- caller picks the element type
export function $<T extends HTMLElement = HTMLElement>(sel: string): T {
  const el = document.querySelector<T>(sel);
  if (!el) throw new Error(`missing element: ${sel}`);
  return el;
}

interface HProps {
  className?: string;
  text?: string;
}

/** Tiny element builder used throughout the UI code. */
export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: HProps = {},
  ...children: (Node | string)[]
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (props.className) el.className = props.className;
  if (props.text !== undefined) el.textContent = props.text;
  if (children.length) el.append(...children);
  return el;
}

/**
 * True while an IME (e.g. 注音) is composing. Safari / older Chromium report the
 * confirming keystroke only as keyCode 229, so both checks are needed.
 */
export function isImeComposing(e: KeyboardEvent): boolean {
  // eslint-disable-next-line @typescript-eslint/no-deprecated -- keyCode 229 is the only IME signal on Safari
  return e.isComposing || e.keyCode === 229;
}

/** Force a style flush so re-adding an animation class restarts it. */
export function restartAnimation(el: HTMLElement, cls: string): void {
  el.classList.remove(cls);
  el.getBoundingClientRect();
  el.classList.add(cls);
}

export const prefersReducedMotion = (): boolean => matchMedia("(prefers-reduced-motion: reduce)").matches;
